<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="card mb-30">

    <!-- Filter area -->
    <div class="ranking-progress-filter-timeline__filter">
        <app-add-more-filter-hq
        [filterModuleName]      = "'AreasalesrankingComponent'"
        [className]             = "'district-progress-filters'"
        [filters]               = "FILTERS"
        [listData_Filter]       = "listData_Filter"
        [lstOption_Selected]    = "lstOption_Selected"
        [lstOption_States]      = "lstOption_States"
        [lstOption_IsUsed]      = "lstOption_IsUsed"
        [defaultVisibleFilters] = "defaultVisibleFilters"
        [sectionName]           = "sectionName"
        (onUpdateChart)         = "updateAreaSalesRankingData($event)"
        (onResetFiltersGroup)   = "onResetFiltersGroup($event)"></app-add-more-filter-hq>
    </div>

    <div *ngIf="lstOption_RankingUnit && lstOption_RankingUnit.length > 0" class="filter-section filter-section__hq-progress even-wrapper">
      <single-dropdown
          title="Ranking Unit"
          [items]="lstOption_RankingUnit"
          [model]="lstOption_Selected_RankingUnit"
          (change)="onSaveChannelLevChange($event)">
      </single-dropdown>
    </div>

    <div *ngIf="isLoading" class="text-center spinner-wrapper spinner-wrapper-icon">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div #pdf_print_salesranking>
        <div class="filter-container-pdf">
            <div class="filter-list row">
                <b class="filter-list-header col-1half">Sales Year Month: </b>
                <div class="filter-list-content col-10half">
                  <span>{{this.saleYearMonth}}</span>
                </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.SALES_HQ_LEV1_NAME == 'enable'">
              <b class="filter-list-header col-1half">Sales HQ Lev1: </b>
              <div class="filter-list-content col-10half">
                  <span>{{lstOption_Selected_Applied.SALES_HQ_LEV1_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.SALES_HQ_LEV2_NAME == 'enable'">
              <b class="filter-list-header col-1half">Sales HQ Lev2: </b>
              <div class="filter-list-content col-10half">
                  <span>{{lstOption_Selected_Applied.SALES_HQ_LEV2_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.SALES_HQ_LEV3_NAME == 'enable'">
              <b class="filter-list-header col-1half">Sales HQ Lev3: </b>
              <div class="filter-list-content col-10half">
                  <span [class]="lstOption_Selected_Applied.SALES_HQ_LEV3_NAME!='All' ? 'japanese-text' : ''">{{lstOption_Selected_Applied.SALES_HQ_LEV3_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.SALES_CENTER_NAME == 'enable'">
              <b class="filter-list-header col-1half">Sales Center: </b>
              <div class="filter-list-content col-10half">
                  <span [class]="lstOption_Selected_Applied.SALES_CENTER_NAME!='All' ? 'japanese-text' : ''">{{lstOption_Selected_Applied.SALES_CENTER_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.SALES_CONTROL_BASE_NAME == 'enable'">
              <b class="filter-list-header col-1half">Sale Control Base: </b>
              <div class="filter-list-content col-10half">
                  <span [class]="lstOption_Selected_Applied.SALES_CONTROL_BASE_NAME!='All' ? 'japanese-text' : ''">{{lstOption_Selected_Applied.SALES_CONTROL_BASE_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.SALES_CONTROL_BASE_ROUTE_CODE == 'enable'">
              <b class="filter-list-header col-1half">Sales Route: </b>
              <div class="filter-list-content col-10half">
                  <span>{{lstOption_Selected_Applied.SALES_CONTROL_BASE_ROUTE_CODE}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.CHANNEL_LEV1_NAME == 'enable'">
              <b class="filter-list-header col-1half">Channel Lev1:</b>
              <div class="filter-list-content col-10half">
                  <span>{{lstOption_Selected_Applied.CHANNEL_LEV1_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.CHANNEL_LEV2_NAME == 'enable'">
              <b class="filter-list-header col-1half">Channel Lev2:</b>
              <div class="filter-list-content col-10half">
                  <span>{{lstOption_Selected_Applied.CHANNEL_LEV2_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row" *ngIf="lstOption_States_Applied.CHANNEL_LEV3_NAME == 'enable'">
              <b class="filter-list-header col-1half">Channel Lev3:</b>
              <div class="filter-list-content col-10half">
                  <span>{{lstOption_Selected_Applied.CHANNEL_LEV3_NAME}}</span>
              </div>
            </div>
            <div class="filter-list row">
              <b class="filter-list-header col-1half">Current Page:</b>
              <div class="filter-list-content col-10half">
                <span>{{paging.current}}/{{paging.totalPage}} sorted by &#40;{{sortColumnName}} {{sortType=="asc" ? "ascending" : "descending"}}&#41;</span>
              </div>
          </div>
        </div>

      <!-- Header area -->
      <div class="card-header d-flex justify-content-between align-items-center hq-progress-title">
        <h3 #observedElement>{{ sectionName }}</h3>
      </div>


      <div class="card-body">
        <div class="market-size-district-route-by-district">
          <table class="intage-market-size district-progress">
            <thead>
              <tr class="row__first">
                <ng-container *ngFor="let item of listColumn; index as j;">
                  <th [class]="item.category.toLowerCase()"  *ngIf="item.isDisplay!==false && item.enableSort==false" rowspan="2">
                    <div>{{item.displayName}}</div>
                  </th>
                </ng-container>
                <th [attr.colspan]="getListColspan()[0]" class="bapc"><div class="text-center"><span>BAPC (cases)</span></div></th>
                <th [attr.colspan]="getListColspan()[1]" class="nsr"><div class="text-center"><span>NSR (K JPY)</span></div></th>
                <th [attr.colspan]="getListColspan()[2]" class="nsr"><div class="text-center"><span>NSR per Case (JPY)</span></div></th>
                <th [attr.colspan]="getListColspan()[3]" class="gp"><div class="text-center"><span>GP (K JPY)</span></div></th>
                <th [attr.colspan]="getListColspan()[4]" class="gp"><div class="text-center"><span>GP per Case (JPY)</span></div></th>
            </tr>
              <tr class="row__second">
                <ng-container *ngFor="let item of listColumn; index as j;">
                  <ng-container>
                    <th [class]="item.category.toLowerCase()" *ngIf="item.isDisplay!==false && item.enableSort!=false" (click)="sortTable(item.sortType,item.category)">
                      <div class="th-header-content">
                        <div class="text" [innerHTML]="item.displayName"></div>
                        <div class="sort-column">
                          <div class="icon-container sort-column">
                            <span id="NSR_DIFF_VS_BPASC" class='icon-up-arrow' [ngClass]="sortType == 'asc' && sortColumn ==item.category ? 'red' : ''"></span>
                            <span id="NSR_DIFF_VS_BPDESC" class='icon-down-arrow' [ngClass]="sortType == 'desc' && sortColumn ==item.category ? 'red' : ''"></span>
                          </div>
                        </div>
                      </div>
                    </th>
                  </ng-container>
                </ng-container>
              </tr>
            </thead>

            <tbody *ngIf="!isLoading">
              <ng-container *ngFor="let root1 of areaSalesRankingData?.Total; index as i;">
                <tr>
                  <ng-container *ngFor="let item of listColumn; index as j;">
                    <td class="item-chanel-1" [class]="' ' + item.category.toLowerCase()" *ngIf="item.isDisplay!==false">
                      <span>
                        <b
                          [class]="(!item.isLunisolarColor|| !root1[item.category]) ? '': root1[item.category].toString().indexOf('-') == 0 ? 'text-red' : 'text-green'">
                          {{root1[item.category +'_Display']}}
                        </b>
                      </span>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>

              <ng-container *ngFor="let root1 of areaSalesRankingData?.ListAll; index as i;">
                <tr>
                  <ng-container *ngFor="let item of listColumn; index as j;">
                    <td class="item-chanel-1" [class]="' ' + item.category.toLowerCase()" *ngIf="item.isDisplay!==false">
                      <span>
                        <b
                          [class]="(!item.isLunisolarColor|| !root1[item.category]) ? '': root1[item.category].toString().indexOf('-') == 0 ? 'text-red' : 'text-green'">
                          {{root1[item.category +'_Display']}}
                        </b>
                      </span>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

    </div>

      <!-- Paging -->
      <div *ngIf="paging?.totalPage > 1" class="paging-section">
        <ngb-pagination class="ngb-pagination"
          [collectionSize]="paging?.totalPage *10"
          [(page)]="paging.current"
          [rotate]="true"
          [maxSize]="paging.maxSize"
          [directionLinks]="true"
          [boundaryLinks]="true"
          (pageChange)="onPageChange($event); onTrackingPaging($event)">
        </ngb-pagination>
      </div>

      <!-- Download CSV area -->
      <div class="d-flex flex-row-reverse mt-4">
        <download-button [ngClass]=" isLoading ? 'disable-button' :''">
          <a #downloadLink style="display: none;"></a>
          <button *ngIf="!isLoading" ngbDropdownItem (click)="export_CSV()">Current Page CSV</button>
          <!-- <button *ngIf="!isLoading" ngbDropdownItem (click)="exportHQDistrict_PDF('Progress by District')">Current Page PDF</button> -->
          <button *ngIf="!isLoading" ngbDropdownItem (click)="handle_export_All_CSV()">{{this.allCSVButtonText}}</button>
        </download-button>
      </div>
    </div>
  </div>
</div>
